import $ from "jquery";
window.$ = window.jQuery = $;

$(document).ready(function() {
    $('.accordion button').on('click', function() {
      // Toggle only this item, checking its current state
      var currentState = $(this).attr('aria-expanded') === 'true';
  
      // Close all items first
      $('.accordion button').attr('aria-expanded', 'false');
  
      // Set the state of the clicked item based on its previous state
      $(this).attr('aria-expanded', !currentState);
    });

    setTimeout(function() {
        $('.astronaut').addClass('show');
        $('.tag').addClass('show');
    }, 1000);
});


// (function ($) {
//   $.fn.initPinOnScroll = function () {
//       'use strict';
//       var $elements = $('[scroll-pin]');

//       function updatePin() {
//           var scrollTop = $window.scrollTop();

//           $elements.each(function () {
//               var $el = $(this);
//               var pinDuration = parseInt($el.attr('scroll-pin'), 10);

//               console

//               var initialTop = $el.data('initialTop') || $el.offset().top;
//               $el.data('initialTop', initialTop);

//               var elWidth = $el.outerWidth();
//               var elHeight = $el.outerHeight();

//               var pinEnd = (initialTop + pinDuration);

//               $el.data('initialTop', initialTop);

//               if (!$el.parent().hasClass('scroll-wrapper')) {
//                   var $wrapper = $('<div class="scroll-wrapper"></div>');
//                   var cssProperties = {
//                       order: 0,
//                       placeSelf: 'auto',
//                       gridArea: 'auto',
//                       zIndex: 'auto',
//                       float: 'none',
//                       flexShrink: 1,
//                       display: 'block',
//                       margin: '0px',
//                       position: 'relative',
//                       flexBasis: 'auto',
//                       overflow: 'visible',
//                       boxSizing: 'border-box',
//                       width: elWidth,
//                       height: elHeight,
//                       padding: '0px 0px ' + (pinDuration + elHeight) + 'px',
//                   };

//                   var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
//                   if (isSafari) {
//                       cssProperties['alignSelf'] = 'auto';
//                       cssProperties['justifySelf'] = 'auto';
//                       cssProperties['gridRowStart'] = 'auto';
//                       cssProperties['gridColumnStart'] = 'auto';
//                       cssProperties['gridRowEnd'] = 'auto';
//                       cssProperties['gridColumnEnd'] = 'auto';
//                   }

//                   $wrapper.css(cssProperties);
//                   $el.wrap($wrapper);
//               }

//               if (scrollTop > initialTop && scrollTop < pinEnd) {

//                   $el.css({
//                       transform: 'none',
//                       rotate: 'none',
//                       scale: 'none',
//                       left: '0px',
//                       top: '0px',
//                       margin: '0px',
//                       maxWidth: elWidth,
//                       width: elWidth,
//                       maxHeight: elHeight,
//                       height: elHeight,
//                       padding: '0px',
//                       boxSizing: 'border-box',
//                       position: 'fixed',
//                       transform: 'translate(0px, 0px)',
//                   });

//               } else if (scrollTop >= pinEnd) {

//                   $el.css({
//                       transform: 'none',
//                       rotate: 'none',
//                       scale: 'none',
//                       left: '',
//                       top: '',
//                       inset: '0px auto auto 0px',
//                       margin: '0px',
//                       maxWidth: elWidth,
//                       width: elWidth,
//                       maxHeight: elHeight,
//                       height: elHeight,
//                       padding: '0px',
//                       boxSizing: '',
//                       position: '',
//                       transform: 'translate(0px, ' + ((scrollTop - initialTop) - (scrollTop - pinEnd)) + 'px)',
//                   });

//               } else {

//                   $el.css({
//                       transform: 'none',
//                       rotate: 'none',
//                       scale: 'none',
//                       left: '',
//                       top: '',
//                       inset: '0px auto auto 0px',
//                       margin: '0px',
//                       maxWidth: elWidth,
//                       width: elWidth,
//                       maxHeight: elHeight,
//                       height: elHeight,
//                       padding: '0px',
//                       boxSizing: '',
//                       position: '',
//                       transform: 'translate(0px, 0px)',
//                   });

//               }
//           });

//           isScrolling = false;
//       }

//       function onScroll() {
//           if (!isScrolling) {
//               requestAnimationFrame(updatePin);
//               isScrolling = true;
//           }
//       }

//       var $window = $(window);
//       var isScrolling = false;

//       $window.on('scroll', onScroll);
//   };

//   $(document).ready(function () {
//       $.fn.initPinOnScroll();
//   });
// }(jQuery));

// (function ($) {
//   'use strict';
//   $.fn.horizontalScroll = function () {
//       var $elements = $('[scroll-horizontal]');

//       function updatePin() {
//           var scrollTop = $window.scrollTop();

//           // Exit early if no elements found
//           if (!$elements.length) return;

//           $elements.each(function () {
//               var $el = $(this);
//               var pinDuration = parseInt($el.attr('scroll-horizontal'), 10);

//               // Check if pinDuration is a valid number
//               if (isNaN(pinDuration)) return;

//               var initialTop = $el.data('initialTop') || $el.offset().top;
//               $el.data('initialTop', initialTop);

//               var elWidth = $el.outerWidth();
//               var elHeight = $el.outerHeight();

//               var pinEnd = (initialTop + pinDuration);

//               // Check if user has scrolled within the pinning area
//               if (scrollTop > initialTop && scrollTop < pinEnd) {
//                   $el.scrollLeft((scrollTop - initialTop));
//               }
//           });

//           isScrolling = false;
//       }

//       function onScroll() {
//           if (!isScrolling) {
//               requestAnimationFrame(updatePin);
//               isScrolling = true;
//           }
//       }

//       var $window = $(window);
//       var isScrolling = false;

//       // Use EventListener for better performance
//       $window[0].addEventListener('scroll', onScroll);
//   };

//   // Call the function on document ready
//   $(function () {
//       $.fn.horizontalScroll();
//   });
// }(jQuery));

// (function ($) {
//   'use strict';

//   function handleScrollClasses() {
//       var viewportTop = $window.scrollTop();
//       var viewportBottom = viewportTop + window.innerHeight;

//       $('[scroll-add-class]').each(function () {
//           var $el = $(this);
//           var elementTop = $el.offset().top;
//           var elementBottom = elementTop + $el.outerHeight();
//           var elementClass = $el.attr('scroll-add-class');

//           if (elementBottom > viewportTop && elementTop < viewportBottom) {
//               $el.addClass(elementClass);
//           } else {
//               $el.removeClass(elementClass);
//           }
//       });
//   }

//   var $window = $(window);

//   $window.on('scroll', handleScrollClasses);

//   $(document).ready(function () {
//       handleScrollClasses();
//   });
// }(jQuery));

// (function ($) {
//   'use strict';
//   $.fn.addChildClassScroll = function () {
//       var $elements = $('[scroll-animate]');
//       var $navItems = $elements.find('.animate');
//       var numNavItems = $navItems.length;

//       function updatePin() {
//           var scrollTop = $window.scrollTop();

//           // Exit early if no elements found
//           if (!$elements.length) return;

//           $elements.each(function () {
//               var $el = $(this);
//               var pinDuration = parseInt($el.attr('scroll-animate'), 10);

//               // Check if pinDuration is a valid number
//               if (isNaN(pinDuration)) return;

//               var initialTop = $el.data('initialTop') || $el.offset().top;
//               $el.data('initialTop', initialTop);

//               var elWidth = $el.outerWidth();
//               var elHeight = $el.outerHeight();

//               var pinEnd = (initialTop + pinDuration);

//               // Check if user has scrolled within the pinning area
//               if (scrollTop > initialTop && scrollTop < pinEnd) {
//                   $el.scrollLeft();

//                   var scrollPercentage = ((scrollTop - initialTop) / pinDuration) * 100;

//                   if (!$elements.length) return;


//                   // Calculate which tab to activate based on scroll percentage
//                   var activeTabIndex = Math.floor(scrollPercentage / (100 / numNavItems));

//                   // Ensure the index is within the range of available tabs
//                   activeTabIndex = Math.min(Math.max(activeTabIndex, 0), numNavItems - 1);

//                   // Trigger click on the corresponding nav link
//                   $navItems.eq(activeTabIndex).addClass('active');
                  
//               }else{
//                   if(scrollTop < pinEnd){
//                       $navItems.removeClass('active');
//                   }      
//               }
//           });

//           isScrolling = false;
//       }

//       function onScroll() {
//           if (!isScrolling) {
//               requestAnimationFrame(updatePin);
//               isScrolling = true;
//           }
//       }
      
//       var $window = $(window);
//       var isScrolling = false;

//       // Use EventListener for better performance
//       $window[0].addEventListener('scroll', onScroll);
//   };

//   // Call the function on document ready
//   $(function () {
//       $.fn.addChildClassScroll();
//   });
// }(jQuery));
